import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { HiOutlineAcademicCap, HiOutlineCalendar, HiOutlineLocationMarker } from "react-icons/hi";

function AdmissionsOpen() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [admissionPosts, setAdmissionPosts] = useState([]);

  useEffect(() => {
    // Simulate API fetch
    const timer = setTimeout(() => {
      setAdmissionPosts([
        {
          id: 1,
          college: "GL Mehta College of Training",
          title: "Annual College Fest",
          description: "Join us on March 15, 2025 for music, dance, and unlimited fun fest! Various competitions and workshops available.",
          image: "/assets/imageu.png"
        },
        {
          id: 2,
          college: "Science & Technology Institute",
          title: "New Course Admissions",
          description: "Applications now open for our new AI and Data Science programs. Limited seats available for 2025 batch.",
          image: "/assets/imageu.png"
        }
      ]);
      setLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.5 }
    }
  };

  // Skeleton Loader Component
  const AdmissionSkeleton = () => (
    <div className="bg-white/90 backdrop-blur-sm rounded-xl shadow-sm overflow-hidden border border-indigo-100 animate-pulse">
      <div className="flex p-4">
        <div className="w-20 h-20 rounded-lg bg-gradient-to-r from-indigo-200 to-purple-200"></div>
        <div className="ml-4 flex-1 space-y-2">
          <div className="h-4 w-3/4 bg-indigo-200 rounded"></div>
          <div className="h-3 w-1/2 bg-indigo-200 rounded"></div>
          <div className="h-3 w-full bg-indigo-200 rounded"></div>
          <div className="h-3 w-4/5 bg-indigo-200 rounded"></div>
          <div className="h-4 w-20 bg-indigo-200 rounded mt-3"></div>
        </div>
      </div>
    </div>
  );

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      className="space-y-6"
    >
      <div className="flex items-center space-x-2 px-2">
        <div className="w-8 h-8 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-lg flex items-center justify-center">
          <HiOutlineAcademicCap className="w-4 h-4 text-white" />
        </div>
        <h2 className="text-xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
          Admissions Open
        </h2>
      </div>
      
      {loading ? (
        <>
          <AdmissionSkeleton />
          <AdmissionSkeleton />
        </>
      ) : (
        <>
          {admissionPosts.map((post, index) => (
            <motion.div
              key={post.id}
              variants={itemVariants}
              custom={index}
              whileHover={{ y: -4 }}
              className="bg-white/90 backdrop-blur-sm rounded-xl shadow-md overflow-hidden border border-indigo-100 hover:shadow-lg transition-all duration-300"
            >
              <div className="flex p-4">
                <img
                  src={post.image}
                  alt="College"
                  className="w-20 h-20 rounded-lg object-cover border-2 border-indigo-200"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "assets/default-college.png";
                  }}
                />
                <div className="ml-4 flex-1">
                  <h3 className="font-semibold text-gray-800">{post.college}</h3>
                  <p className="text-sm text-indigo-600 mt-1 font-medium line-clamp-1">
                    {post.title}
                  </p>
                  <p className="text-xs text-gray-500 mt-1 line-clamp-2">
                    {post.description}
                  </p>
                  <motion.button
                    whileHover={{ x: 5 }}
                    onClick={() => navigate("/courses")}
                    className="mt-3 text-indigo-600 text-sm font-medium flex items-center hover:text-indigo-700 transition-colors"
                  >
                    Apply Now
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </motion.button>
                </div>
              </div>
            </motion.div>
          ))}
        </>
      )}
      
      <motion.button
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        onClick={() => navigate("/courses")}
        className={`w-full py-3 text-indigo-600 rounded-xl text-sm font-medium transition-all duration-300 ${
          loading 
            ? "bg-gradient-to-r from-indigo-200 to-purple-200 animate-pulse h-12" 
            : "bg-indigo-50 hover:bg-indigo-100 border border-indigo-200"
        }`}
        disabled={loading}
      >
        {loading ? "" : "View All Admissions →"}
      </motion.button>
    </motion.div>
  );
}

export default AdmissionsOpen;